import { Form, Select } from 'antd'
import * as React from 'react'
import { FC } from 'react'
import { useGetContractorsQuery } from '../../../../../../../../../../store/api/contractors-api'
import { QueryParams } from '../../../../../../../../../../types/strapi/strapi'

const params: QueryParams = {
    filters: { type: { name: { $contains: 'Поставщик материала' } } },
}

interface SupplierProps {
    onChange?: () => void
}

const Supplier: FC<SupplierProps> = ({ onChange }) => {
    const { data: contractors } = useGetContractorsQuery(params)

    return (
        <Form.Item name={'supplier'} label={'Поставщик'}>
            <Select
                disabled
                onChange={onChange}
                style={{ width: '100%' }}
                options={contractors?.data.map(x => ({
                    label: x.name,
                    value: x.documentId,
                }))}
            />
        </Form.Item>
    )
}

export default Supplier
